import { FC, useEffect, useState } from "react";
import Router from "./routes/Router";
import LocalStorageLanguageRepository from "details/storage/localStorage/repositories/localStorageLanguageRepository/LocalStorageLanguageRepository";
import internationalizationService from "./shared/services/internationalizationService";
import AppZustandProvider from "./shared/contexts/AppContextProvider";
import { ServiceContainerProvider } from "@/core/di";
import { Toaster } from "@/components/ui/sonner";
import { getDeviceFingerprint } from "@/lib/utils";

internationalizationService.init(new LocalStorageLanguageRepository());

const App: FC = () => {
  const [fingerprint, setFingerprint] = useState<string | null>(
    localStorage.getItem("fingerprint"),
  );

  useEffect(() => {
    // Fetch fingerprint si nécessaire
    if (!fingerprint) {
      getDeviceFingerprint().then((fp) => {
        localStorage.setItem("fingerprint", fp);
        setFingerprint(fp);
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // exécution une seule fois au montage

  return (
    <ServiceContainerProvider>
      <AppZustandProvider>
        <Router />
        <Toaster closeButton />
      </AppZustandProvider>
    </ServiceContainerProvider>
  );
};

export default App;
